/**
 * GA4 SPA page-view tracking (2026-09-21).
 *
 * The app has no router and never touches the real browser URL (App.tsx's
 * `route` is pure in-memory state -- confirmed before wiring this: the
 * whole SPA renders at "/" always). GA4's default gtag.js snippet
 * (index.html) only fires ONE automatic page_view, on that single initial
 * load -- it has no way to see a route change that never touches
 * `window.location`. This fires a manual page_view on every `route.view`
 * change instead, using a synthetic page_path (`/app/<view>`) rather than
 * altering real browser history -- no router was added for this.
 *
 * DELIBERATE SAFETY BOUNDARY: only the route's `view` discriminant is sent
 * (e.g. "detail", "model") -- never `securityId`, `modelId`, `version`, or
 * any other field on the route. Those identify which stock/model a user is
 * researching, which is exactly the research-data-into-a-third-party-
 * analytics-tool case this build was told to avoid. This file must stay
 * the ONLY caller of gtag('event', 'page_view', ...) -- do not add a
 * second call site elsewhere that might pass a route's data fields through.
 */
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackPageView(viewName: string): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: `Tickerpicker - ${viewName}`,
    page_location: window.location.href,
    page_path: `/app/${viewName}`,
  });
}
